import { createFeature, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { StripePriceProductActions } from '../actions/stripe-price-product.actions';
import { ErrorStore, StripePriceProduct } from '@sleipai/sleip-models';

export const stripePriceProductsFeatureKey = 'stripePriceProducts';

export interface State extends EntityState<StripePriceProduct> {
  loaded: boolean;
  loading: boolean;
  error: ErrorStore | null;
}

export const adapter: EntityAdapter<StripePriceProduct> =
  createEntityAdapter<StripePriceProduct>();

export const initialState: State = adapter.getInitialState({
  loading: false,
  loaded: false,
  error: null,
});

export const reducer = createReducer(
  initialState,
  on(StripePriceProductActions.loadStripePriceProducts, (state) => {
    return {
      ...state,
      loading: true,
      error: null,
    };
  }),
  on(
    StripePriceProductActions.loadStripePriceProductsSuccess,
    (state, { stripePriceProducts }) => {
      return adapter.upsertMany(stripePriceProducts, {
        ...state,
        loading: false,
        loaded: true,
      });
    }
  ),
  on(
    StripePriceProductActions.loadStripePriceProductsFailure,
    (state, { error }) => {
      return {
        ...state,
        loaded: true,
        loading: false,
        error: {
          message: error['message'],
          status: error['status'],
        },
      };
    }
  ),
  on(StripePriceProductActions.addStripePriceProduct, (state, action) =>
    adapter.addOne(action.stripePriceProduct, state)
  ),
  on(StripePriceProductActions.addStripePriceProducts, (state, action) =>
    adapter.addMany(action.stripePriceProducts, state)
  ),
  on(StripePriceProductActions.deleteStripePriceProduct, (state, action) =>
    adapter.removeOne(action.id, state)
  ),
  on(StripePriceProductActions.deleteStripePriceProducts, (state, action) =>
    adapter.removeMany(action.ids, state)
  ),
  on(StripePriceProductActions.clearStripePriceProducts, (state) =>
    adapter.removeAll(state)
  )
);

export const stripePriceProductsFeature = createFeature({
  name: stripePriceProductsFeatureKey,
  reducer,
});

export const {
  selectIds: selectStripePriceProductsEntitiesIdsAdapter,
  selectEntities: selectStripePriceProductsEntitiesAdapter,
  selectAll: selectAllStripePriceProductsAdapter,
  selectTotal: selectStripePriceProductsTotalAdapter,
} = adapter.getSelectors();
